<template>
  <div
    class="content pay-result"
    :class="{
      'in-mobile': isHXApp || isH5,
      'pad-app-pay-result': isMGAppInPad,
      'electron-pay-result': isElectron,
    }"
  >
    <template v-if="orderInfo?.state">
      <!-- 移动 -->
      <template v-if="orderInfo && (isHXApp || isH5)">
        <!-- 成功 -->
        <MobileHavQrcode
          v-if="orderInfo.state === 2"
          :showAssistant="showAssistant"
          :orderInfo="orderInfo"
          :courseInfo="courseInfo"
          @jumpStudy="jumpStudy"
          :typeTips="typeTips"
          :union_id="Number(union_id)"
          @goLearningCenter="goLearningCenter"
          @copyNumber="copyNumber"
        />
        <!-- 失败 -->
        <mobile-main
          v-else
          :orderInfo="orderInfo"
          :msgInfo="{ type: orderInfo.state === 2 ? 'success' : 'error' }"
          :text-price="orderInfo.real_price / 100"
          :text-title="orderInfo.goods_title"
          :link-trade="'/trade'"
          :text-trade="'查看交易'"
          :link-study="'/my-course'"
          :text-study="'立即学习'"
        ></mobile-main>
      </template>
      <!-- web -->
      <template v-else>
        <!-- 成功 -->
        <div
          v-if="orderInfo.state === 2"
          class="success-wrap"
          :class="{
            'have-helper': showAssistant && orderInfo.assistant.contact_way,
          }"
        >
          <div class="success-result-info">
            <img class="icon" src="../../assets/images/dui-icon.png" alt="" />
            <p>恭喜您，交易成功！</p>
          </div>
          <!-- 小助手 -->
          <div v-if="showAssistant" class="qrcode-wrap-helper">
            <p class="title">{{ orderInfo.assistant.guide }}</p>
            <img
              class="qrcode"
              :src="orderInfo.assistant.img_url + '?imageView2/0/w/400'"
              alt=""
            />
            <p class="type-tips" v-html="typeTips"></p>
            <div v-if="orderInfo.assistant.contact_way" class="copy-wrap">
              <p class="contact-number">
                {{ orderInfo.assistant.contact_way }}
              </p>
              <button class="copy-btn" @click="copyNumber">
                <img src="../../assets/images/copy-icon.png" alt="" />
              </button>
            </div>
          </div>
          <!-- 默认 -->
          <div v-else class="qrcode-wrap">
            <div class="title">
              <p>扫码关注魔果云课服务号</p>
              <p>及时获取课程通知</p>
            </div>
            <img
              class="qrcode"
              src="https://cdn.moguocdn.com/image/web_assets/qrcode_for_gh_d94af974800d_430_3.png"
              alt=""
            />
          </div>
          <hr />
          <div class="course-info-wrap">
            <img
              class="cover"
              :src="
                handleImageUrl(courseInfo.goods_cover_url) +
                '?imageView2/0/w/200'
              "
              alt=""
            />
            <p class="course-title">
              {{ courseInfo.goods_title }}
            </p>
            <template v-if="!isWebPageInElectron">
              <button v-if="!union_id" class="go-study-btn" @click="jumpStudy">
                立即上课
              </button>
              <button v-else class="go-study-btn" @click="goLearningCenter">
                去学习中心
              </button>
            </template>
          </div>
        </div>
        <!-- 失败 -->
        <div v-else class="content-wrap fail-wrap">
          <div class="result-info">
            <img class="icon" src="@/assets/img/error-icon.png" alt="" />
            <p>支付失败，请您重新尝试！</p>
          </div>
          <p v-if="!isWebPageInElectron" class="link-wrap">
            <router-link :to="'/payment/' + orderInfo.order_no"
              >重新支付</router-link
            >
            <router-link :to="{ name: 'Trade' }">查看我的交易</router-link>
          </p>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { getJointInfo } from "@saas/server-api/src/joint-purchase/index";
import { CONTACT_WAY_TYPE } from "@saas/components/src/utils/constants.js";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import {
  MobileHavQrcode,
  MobileMain,
  isH5,
  isWebPageInElectron,
  isMobile,
  isHXApp,
  isMGAppInPad,
  clipboard,
  handleImageUrl,
} from "@saas/components/src";
import { getOrder } from "@saas/server-api/src/product-details";
export default {
  data: function () {
    return {
      handleImageUrl,
      orderInfo: {},
      isH5: isH5(),
      isMobile: isMobile(),
      isHXApp: isHXApp(),
      isWebPageInElectron: isWebPageInElectron(),
      isMGAppInPad: isMGAppInPad(),
      isElectron: window.isElectron,
      contactType: CONTACT_WAY_TYPE,
      courseInfo: {},
      union_id: "",
    };
  },
  mounted() {
    // 获取订单详情
    this.apiGetOrder();
  },
  computed: {
    showAssistant() {
      return !!this.orderInfo.assistant;
    },
    typeTips() {
      if (this.orderInfo.assistant) {
        let type = this.orderInfo.assistant.contact_way_type;
        if (type === this.contactType.NO_WAY) {
          return "";
        } else if (type === this.contactType.WX) {
          return `使用<span>微信</span>扫码，添加老师或进群。您也可手动添加<span>微信号</span>:`;
        } else {
          if (type === this.contactType.QQ) {
            return `使用<span>QQ</span>扫码，添加老师或进群。您也可手动添加<span>QQ号</span>:`;
          } else {
            return `使用<span>QQ</span>扫码，添加老师或进群。您也可手动添加<span>QQ群</span>:`;
          }
        }
      } else {
        return "";
      }
    },
  },
  methods: {
    jumpStudy() {
      if (this.isHXApp) {
        let params = {
          courseId: this.courseInfo.course_id,
        };
        let otherData = {
          name: "myCourseDetail",
        };
        jsToFlutter("openPage", params, otherData);
      } else {
        this.$router.push({
          name: "myCourseDetail",
          params: { id: this.courseInfo.course_id },
        });
      }
    },
    goLearningCenter() {
      // 学习中心
      if (this.isHXApp) {
        jsToFlutter("toMain", { index: 1 });
      } else {
        this.$router.push({
          name: "myCourse",
        });
      }
    },
    copyNumber() {
      clipboard(this.orderInfo.assistant.contact_way, () => {
        this.$showToast("联系方式复制成功");
      });
    },
    apiGetOrder() {
      getOrder({ order_no: this.$route.params.order_no }).then((res) => {
        if (res.code === 1) {
          this.orderInfo = res.data || {};
          let { state, sub_order_list, activity_id } = this.orderInfo;
          if (this.isH5 || this.isHXApp) {
            // 修改标题

            if (state === 2) {
              document.title = "支付成功";
            } else {
              document.title = "超时未支付";
            }
            jsToFlutter("setTitle", { title: document.title });
          }
          if (state === 2) {
            if (sub_order_list.length === 1) {
              this.union_id = "";
              let { course_id, goods_title, goods_cover_url } =
                sub_order_list[0];
              this.courseInfo = {
                course_id,
                goods_title,
                goods_cover_url,
              };
            } else if (activity_id) {
              this.union_id = activity_id;
              let params = {
                union_id: activity_id,
              };
              getJointInfo(params).then((res) => {
                if (res.code === 1) {
                  let data = res.data || {};
                  let { head_img, title } = data;
                  this.courseInfo = {
                    goods_title: title,
                    goods_cover_url: head_img,
                  };
                } else {
                  this.$message.error(res.message);
                }
              });
            }
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  components: {
    "mobile-main": MobileMain,
    MobileHavQrcode,
  },
};
</script>

<style lang="scss" scoped>
.pay-result.pad-app-pay-result {
  max-width: 375px;
}
.pay-result.in-mobile {
  min-height: 100vh;
  background: #fff;
}
.pay-result {
  // max-width: 768px;
  width: 100%;
  padding: 40px 15px 40px;
  background: #fff;
  .content-wrap {
    .result-info {
      display: flex;
      align-items: center;
      font-size: 18px;
      line-height: 30px;
      .icon {
        height: 80px;
        margin-right: 20px;
      }
    }
    .link-wrap {
      padding-left: 120px;
      margin-top: 20px;
      a {
        margin-right: 30px;
        color: $saas-theme-color;
      }
    }
  }

  // 支付成功
  .success-wrap {
    padding: 48px 0 32px;
    width: 560px;
    min-height: 606px;
    background: #ffffff;
    margin: 0 auto;
    background-image: url("../../assets/images/pay-result/pay-success-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    &.have-helper {
      background-image: url("../../assets/images/pay-result/pay-success-bg2.png");
    }
    .success-result-info {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 24px;
      color: #0d1400;
      line-height: 33px;
      margin-bottom: 30px;
      justify-content: center;
      .icon {
        width: 32px;
        height: 32px;
        margin-right: 16px;
      }
    }
    // 课程-小助手
    .qrcode-wrap-helper {
      position: relative;
      margin: 0 auto;
      width: 300px;
      max-height: 512px;
      background: linear-gradient(42deg, #daffef 0%, #ffffff 100%);
      border-radius: 16px;
      padding: 24px 16px 28px;
      margin-bottom: 22px;
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #0d1400;
        line-height: 24px;
        width: 260px;
        height: 54px;
        border-radius: 8px;
        background: rgba($color: #ffffff, $alpha: 0.6);
        margin: 0 auto 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
      .qrcode {
        width: 200px;
        max-height: 260px;
        margin: 0 auto 20px;
      }
      ::v-deep .type-tips {
        font-size: 15px;
        color: #0d1400;
        line-height: 24px;
        margin-bottom: 14px;
        span {
          font-weight: bold;
        }
      }
      .copy-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 260px;
        height: 54px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #00c89d;
        margin: 0 auto;
        padding: 0 8px 0 8px;
        font-weight: 500;
        font-size: 30px;
        color: #0d1400;
        line-height: 1;
        .copy-btn {
          width: 14px;
          height: 14px;
          margin-left: 8px;
        }
        .contact-number {
          flex: 1;
          width: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          line-break: anywhere;
          text-align: center;
        }
      }
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        content: "";
        width: 60px;
        height: 52px;
        background-image: url("../../assets/images/pay-result/logo-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    // 默认
    .qrcode-wrap {
      position: relative;
      margin: 0 auto;
      width: 300px;
      background: linear-gradient(42deg, #daffef 0%, #ffffff 100%);
      border-radius: 16px;
      padding: 24px 0 38px;
      margin-bottom: 32px;
      .title {
        text-align: center;
        font-weight: 500;
        font-size: 15px;
        color: #0d1400;
        line-height: 24px;
        margin-bottom: 20px;
      }
      .qrcode {
        width: 200px;
        height: 200px;
        margin: 0 auto;
      }
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        content: "";
        width: 60px;
        height: 52px;
        background-image: url("../../assets/images/pay-result/logo-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    hr {
      width: 498px;
      height: 1px;
      border: 1px dashed #efefef;
      margin: 0 auto 20px;
    }
    // 课程信息/联报信息
    .course-info-wrap {
      display: flex;
      align-items: center;
      width: 500px;
      height: 80px;
      border-radius: 12px;
      border: 1px solid #efefef;
      padding: 12px 20px 12px 12px;
      margin: 0 auto;
      .cover {
        width: 100px;
        height: 56px;
        border-radius: 9px;
        margin-right: 12px;
        object-fit: cover;
      }
      .course-title {
        height: 44px;
        flex: 1;
        width: 0;
        font-weight: 500;
        font-size: 16px;
        color: #0d1400;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .go-study-btn {
        font-weight: 600;
        font-size: 16px;
        color: #ffffff;
        line-height: 1;
        width: 110px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-radius: 12px;
        margin-left: 12px;
      }
    }
  }

  // 支付失败
  .fail-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

// electron
.electron-pay-result {
  width: calc(100% - 40px);
  max-width: none;
  margin: 0 20px;
  background: #ffffff;
  border-radius: 16px;
}
@media (max-width: 767px) {
  .pay-result {
    padding: 1.36rem 0.67rem 0;
    .content-wrap {
      .result-info {
        font-size: 0.48rem;
        line-height: 0.8rem;
        .icon {
          height: 2.13rem;
          margin-right: 0.53rem;
        }
      }
      .link-wrap {
        display: flex;
        justify-content: space-around;
        text-align: center;
        padding-left: 0;
        a {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
